import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const NavigationEventsClient_Localization_Fragment =
  graphqlShopifyStorefront(`
  fragment NavigationEventsClient_Localization on Localization {
    country {
      availableLanguages {
        isoCode
      }
      currency {
        isoCode
      }
      isoCode
      name
    }
  }
`);
